import React from 'react';
import { Box, Typography, Card, CardContent, List, ListItem, ListItemText, Divider } from '@mui/material';

const SectorulMassMedia: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Sectorul Mass-Media, Comunicare, Dialog și Relații Publice
      </Typography>
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Departamente
          </Typography>
          <List>
            <ListItem>
              <ListItemText 
                primary="Departamentul Mass-Media" 
                secondary="Responsabil pentru activitățile media"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Departamentul de Comunicare" 
                secondary="Responsabil pentru comunicarea internă și externă"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Departamentul de Dialog" 
                secondary="Responsabil pentru dialogul interconfesional"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Departamentul de Relații Publice" 
                secondary="Responsabil pentru relațiile publice"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText 
                primary="Centrul de Presă" 
                secondary="Responsabil pentru activitățile de presă"
              />
            </ListItem>
          </List>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SectorulMassMedia;
